export class ValueClockModel {
  hora = 0;
  minutos = '';
  ampm = '';
  diadesemana = '';
  diaymes = '';
  segundo = '';

  constructor() {
  }
}
